<template>
 <div>
  <el-row style="margin-bottom:10px;">
    <el-col :span="18" class='flex'>
      <el-select v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
          <el-option
              v-for="item in getProjectList_data.data||[]"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId">
          </el-option>
      </el-select>
      <el-select v-model='ucStatus' clearable @change="ucStatusChange" size="small" placeholder="选泽状态" style="margin:0 10px;">
          <el-option
              v-for="item in ucStatusAll"
              :key="item.id"
              :label="item.name"
              :value="item.id" >
          </el-option>
      </el-select>
    </el-col>
  </el-row>
	<mytable
	  :tableColums='tableColums_getSysKeyList'
	  api='getUserCancelList'
	  xupdateapi='updateUserCancelPass'
	  :height="H-163" >
	</mytable>
 </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId: "",
      ucStatus:"",
      ucStatusAll:[
        {id:1,name:"未审核"},
        {id:2,name:"已审核"},

      ],
      input:"",
      userId: null,

      tableColums_getSysKeyList: {
        $selection: false,
        userAccount: '账号',
        ucDesc: '意见',
        createtime:['提交时间',200],
        ucStatus: ['状态',90,'@v-if: 1:未审核#danger, 2:已审核#success'],

        $operation: [
          '操作', 120,
          this.updateUserCancelPass && `@text: 注销账号#success
           @click: _confirm('确定要注销账号吗?')
                   .trigger('updateUserCancelPass',{ucId:$row.ucId})
                   .trigger('getUserCancelList')
          `,
        ],

      },

    };
  },

  watch: {},

  methods: {
    ucStatusChange(e){
      this.ucStatus=e;
      this.getUserCancelList({projectId:this.theProjectId,ucStatus:this.ucStatus});
    },
    theProjectAllChange(e){
        this.theProjectId=e;
        this.getUserCancelList({projectId:this.theProjectId,ucStatus:this.ucStatus});
    },

  },

  created() {
    this.getUserCancelList();
    this.getProjectList({pageSize:0});
  },

};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/help/cancelAccount.vue